module.exports = __webpack_public_path__ + "static/media/Khushu-Pattern.a6b7e727.png";